import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ContainerRejectedBy, RejectedBy, TextStatusRejectedProject } from './style';

const DRAFT_STATUS_REJECTED = 'Draft -';

const RejectedStatus = (props) => {
  const { rejectedBy } = props;

  return (
    <>
      {!_.isEmpty(rejectedBy) && (
        <ContainerRejectedBy>
          <TextStatusRejectedProject>
            {DRAFT_STATUS_REJECTED}
          </TextStatusRejectedProject>
          <RejectedBy>
            Not approved
          </RejectedBy>
        </ContainerRejectedBy>
      )}
    </>
  );
};

RejectedStatus.defaultProps = {
  rejectedBy: {},
};

RejectedStatus.propTypes = {
  rejectedBy: PropTypes.shape({
    user: PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    }),
  }),
};

export default RejectedStatus;
